
import Vue from 'vue';

const component: Vue.FunctionalComponentOptions = {
  functional: true,
  render(createElement, context) {
    return createElement(
      'div', {
        ...context.data,
        class: {
          ...context.data.class,
          'vs-loading': true,
          my: true,
        },
      }, [
        createElement('div', { class: 'effect-1 effects' }),
        createElement('div', { class: 'effect-2 effects' }),
        createElement('div', { class: 'effect-3 effects' }),
      ],
    );
  },
};

export default component;
